<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Roads, Paths &amp; Tracks</div>
				<div class="modal__head__subtitle">Recommended as default by RICS guidance note. </div>
			</div>
			<div class="modal__content">
				<ul>
					<div class="col md-6">
						<li>Back edge of footway</li>
						<li>Camber line on roundabouts</li>
						<li>Carriageway edge</li>
						<li>Centre line road</li>
						<li>Changes of surface material (hard and soft detail)</li>
						<li>Crash barriers</li>
						<li>Gullies, kerb inlets/outlets</li>
					</div>
					<div class="col md-6">
						<li>Kerbs/channel</li>
						<li>Kerbs (dropped)</li>
						<li>Kerbs (top)</li>
						<li>Pedestrian barriers</li>
						<li>Pedestrian crossings</li>
						<li>Rail line level (obtained reflectorlessly)</li>
						<li>Speed humps/tables/traffic islands and calming features</li>
					</div>
				</ul>
				<div class="clearfix"></div>
				<button class="primary" @click="closeModaler">Close</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'RoadsPathsModal',
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/RoadsPathsModal.vue